import type { WorkBook, WritingOptions } from 'xlsx';
import { saveAs } from 'file-saver';

export async function saveExcelSpreadsheet(props: { workbook: WorkBook; fileName: string; options?: WritingOptions }) {
  const { workbook, fileName, options } = props;

  const XLSX = await import(/* webpackPreload: true */ 'xlsx');

  const wbout = XLSX.write(workbook, {
    bookType: 'xlsx',
    bookSST: false,
    ...options,
    type: 'array',
  });

  saveAs(
    new Blob([wbout], {
      type: 'application/octet-stream',
    }),
    fileName,
  );
}
